import React from 'react';

import { AppBar as RAAppBar, Link } from 'react-admin';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

import SearchBar from './SearchBar';
import AppUserMenu from '../AppUserMenu';

const useStyles = makeStyles({
    logo: {
        maxHeight: '34px',
        marginRight: '30px'
    },
});

const AppBar = ({ logo, ...props }) => {
    const classes = useStyles();

    return (
        <RAAppBar {...props} color="primary" userMenu={<AppUserMenu />}>
            <Link to="/">
                <img src={`${process.env.PUBLIC_URL}/img/logo-white.svg`} alt={props.title} className={classes.logo} />
            </Link>
            <Typography variant="h6" id="react-admin-title" color="inherit" />
            <SearchBar />
        </RAAppBar>
    )
};

export default AppBar;
